var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import OffsetGrid from "../inputs/OffsetGrid";
import { Label } from "../inputs/Label";
import Input from "../inputs/Input";
import { useUnitValue } from "../common";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 3;\n\tdisplay: flex;\n"], ["\n\tflex: 3;\n\tdisplay: flex;\n"])));
var Inputs = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: grid;\n\tgrid-template-rows: repeat(3, 1fr);\n\tflex: 2;\n"], ["\n\tdisplay: grid;\n\tgrid-template-rows: repeat(3, 1fr);\n\tflex: 2;\n"])));
var Row = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tgrid-column: 2 / span 2;\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tgrid-column: 2 / span 2;\n\tdisplay: flex;\n\talign-items: center;\n"])));
var Grid = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex: 2;\n"], ["\n\tflex: 2;\n"])));
export default (function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = useUnitValue(value.x), xAmount = _b.amount, xUnit = _b.unit;
    var _c = useUnitValue(value.y), yAmount = _c.amount, yUnit = _c.unit;
    var gridChange = function (_a) {
        var x = _a.x, y = _a.y;
        onChange({ x: ~~x + xUnit, y: ~~y + yUnit });
    };
    var inputChange = function (axis) { return function (val) {
        var _a;
        onChange(__assign(__assign({}, value), (_a = {}, _a[axis] = val, _a)));
    }; };
    return (React.createElement(Wrapper, null,
        React.createElement(Inputs, null,
            React.createElement(Row, null,
                React.createElement(Label, null, "X Offset"),
                React.createElement(Input, { value: value.x, onChange: inputChange("x") })),
            React.createElement(Row, null,
                React.createElement(Label, null, "Y Offset"),
                React.createElement(Input, { value: value.y, onChange: inputChange("y") }))),
        React.createElement(Grid, null,
            React.createElement(OffsetGrid, { offset: { x: xAmount, y: yAmount }, onChange: gridChange }))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=OffsetField.js.map